import { signIn, useSession } from 'next-auth/react'
import { useEffect } from 'react'
import { usePortal } from 'hooks/hooks'

export default function Signin() {
    const [pushPortal] = usePortal()
    const { data: session } = useSession()

    useEffect(() => {
        if (session) {
            pushPortal(`/partners/${session.partner.id}/dashboard`)
        } else {
            signIn('keycloak', { callbackUrl: '/portal/callback' })
        }
    }, [session])

    return <></>
}
